import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { changeDensity } from "store/table/table.slice";
import { AppState } from "store/types";
import { GridDensity } from "@mui/x-data-grid-pro";

const ColumnDensity = () => {
  const dispatch = useDispatch();
  const density = useSelector(
    (state: AppState) => state.table.density
  ) as GridDensity;
  return (
    <Stack direction="row" spacing={2}>
      <Paper
        elevation={3}
        sx={{
          zIndex: 2,
          marginTop: "-20px",

          position: "absolute",
          right: "0px",

          left: "0",
          borderRadius: "0px 0px 8px 8px",

          margin: "0 auto",
          width: "144px",
        }}
      >
        {[
          { id: 1, name: "compact", key: "Compact" },
          { id: 2, name: "standard", key: "Standard" },
          { id: 3, name: "comfortable", key: "Comfortable" },
        ].map(
          ({ id, name, key }: { id: number; name: string; key: string }) => (
            <Box
              sx={{
                padding: "8px",
                backgroundColor:
                  density === name ? "rgba(255, 108, 55, 0.15)" : "",
              }}
              key={id}
            >
              <Typography
                key={id}
                onClick={() => dispatch(changeDensity(name))}
                sx={{
                  fontFamily: "Lato",
                  fontSize: "16px",
                  fontWeight: 400,
                  color: "#424242",
                  cursor: "pointer",
                  fontStyle: "normal",
                  padding: "4px 0",
                }}
              >
                {key}
              </Typography>
            </Box>
          )
        )}
      </Paper>
    </Stack>
  );
};

export default ColumnDensity;
